/* eslint-disable @next/next/next-script-for-ga */
import { CustomThemeProvider } from '@/components/context';
import { appStore } from '@/store';
import '@/styles/GlobalStyles.css';
import type { AppProps } from 'next/app';
import Head from 'next/head';
import { useEffect } from 'react';

function MyApp({ Component, pageProps }: AppProps) {
  useEffect(() => {
    const bodyEl = document.querySelector('body');
    bodyEl?.addEventListener('mousemove', () => appStore.setInteraction());
    bodyEl?.addEventListener('keydown', () => appStore.setInteraction());
    bodyEl?.addEventListener('scroll', () => appStore.setInteraction());

    return () => {
      bodyEl?.removeEventListener('mousemove', () => appStore.setInteraction());
      bodyEl?.removeEventListener('keydown', () => appStore.setInteraction());
      bodyEl?.removeEventListener('scroll', () => appStore.setInteraction());
    };
  }, []);

  return (
    <CustomThemeProvider>
      <Head>
        <title>Mevrik Web Chat | AI-powered Omni-channel Platform for Digital CX, Engagement & Commerce</title>
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
        <meta name="title" content="Redefine Your Digital Customer Experience in Omni-Channel" />
        <meta
          name="description"
          content="Mevrik DCX Platform can help you to increase your Sales, Marketing & Delights your Customer Support with the Help of AI."
        />
        <meta
          name="keywords"
          content="DCX, Digital Customer Experience, AI Chatbot, LiveChat, Social Media, Email, Video Chat, Knowledgebase, Sales Forecasting, AI Based Segmentation, E-Commerce Chatbot, Telecom Chatbot, Banking Chatbot, Web Widget, Messaging SDK, Mobile Chat, In-App Chat"
        />
        <meta name="robots" content="index, follow" />
        <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
        <meta name="language" content="English" />
        <meta name="revisit-after" content="1 days" />
        <meta name="author" content="Gadiel Myron" />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://mevrik.com/" />
        <meta property="og:title" content="Redefine Your Digital Customer Experience in Omni-Channel" />
        <meta
          property="og:description"
          content="Mevrik DCX Platform can help you to increase your Sales, Marketing & Delights your Customer Support with the Help of AI."
        />
        <meta property="og:image" content="/meta-og-image.jpg" />

        {/* Twitter */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content="https://mevrik.com/" />
        <meta property="twitter:title" content="Redefine Your Digital Customer Experience in Omni-Channel" />
        <meta
          property="twitter:description"
          content="Mevrik DCX Platform can help you to increase your Sales, Marketing & Delights your Customer Support with the Help of AI."
        />
        <meta property="twitter:image" content="/meta-og-image.jpg" />
      </Head>
      <Component {...pageProps} />
    </CustomThemeProvider>
  );
}

export default MyApp;
